import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'

export default {
  computed: {
    ...mapState({
      Unit: 'Unit',
      Common: 'Common',
      leftMenuShow:'leftMenuShow',
      docFontSize:'fontSize',
    })
  },
  methods: {
    ...mapMutations({
      SETOPTIONS: 'Unit/SETOPTIONS',
      setLeftMenuShow_M:'SET_LEFTMENU_SHOW',
      setLeftMenuIndex_M:"SET_LEFTMENU_INDEX",
      setSearchData_M:"Unit/setSearchData_M",
      setCreateData_M:"Unit/setCreateData_M",
    }),
    ...mapActions({
      getUnitType_A:"Unit/getUnitType_A",
      getProvinceOrCity_A:"Unit/getProvinceOrCity_A",
      getTableList_A:"Unit/getTableList_A",
      doCreateEditDelete_A:"Unit/doCreateEditDelete_A",
      getUnitDetailWithId_A:"Unit/getUnitDetailWithId_A",
      getUnitStatisticsWithId_A:"Unit/getUnitStatisticsWithId_A",
      getHallList_A:"Unit/getHallList_A",
      getCeremonyList_A:"Unit/getCeremonyList_A",
      getAccountList_A:"Unit/getAccountList_A",
      createOrEditHall_A:"Unit/createOrEditHall_A",
      deleteHall_A:"Unit/deleteHall_A",
      getTemplateAllList_A:"Unit/getTemplateAllList_A",
      templateCreateOrEdit_A:"Unit/templateCreateOrEdit_A",
      deleteTemplate_A:"Unit/deleteTemplate_A"
    })

  }

}




// WEBPACK FOOTER //
// ./src/pages/PartI/UnitManagement/components/Mixins.js